import { Copy, Hash } from "lucide-react";
import { toast } from "@/lib/toast";

export default function TrackingPill({ tn, className = "", testId }) {
  const copy = (e) => {
    e.stopPropagation();
    navigator.clipboard?.writeText(tn);
    toast.success("Tracking number copied");
  };
  return (
    <button type="button" onClick={copy} title="Copy tracking number" data-testid={testId}
      className={`group/pill inline-flex items-center gap-1.5 rounded-lg border border-border bg-slate-50 px-2 py-0.5 font-mono-label text-xs font-semibold text-slate-700 transition-colors hover:border-primary/40 hover:bg-primary/5 hover:text-primary ${className}`}>
      <Hash className="h-3 w-3 opacity-50" />
      <span>{tn}</span>
      <Copy className="h-3 w-3 opacity-0 transition-opacity group-hover/pill:opacity-70" />
    </button>
  );
}
